import { ADD_SELECT_FROM_CART } from '../actionTypes';
import { Icart } from '../initialStates/cartSelections';

export const addSelectFromCart = (items: Icart[]) => {
  return {
    type: ADD_SELECT_FROM_CART,
    payload: items
  };
};
